export default __webpack_public_path__ + "static/media/saco-mujer.6f9206f5.png";